import { render, staticRenderFns } from "./LocalDBWarningBox.vue?vue&type=template&id=b211c508&scoped=true"
import script from "./LocalDBWarningBox.vue?vue&type=script&lang=js"
export * from "./LocalDBWarningBox.vue?vue&type=script&lang=js"
import style0 from "./LocalDBWarningBox.vue?vue&type=style&index=0&id=b211c508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b211c508",
  null
  
)

export default component.exports